import {
  GetSystemLogsSuccessAction,
  GetSystemLogsResponse,
  GetSystemLogsFailureAction,
  GetSystemLogsRequestAction,
  GetSystemLogsPayload
} from './systemLogs.types';

export const getSystemLogsRequest = (
  payload: GetSystemLogsPayload
): GetSystemLogsRequestAction => ({
  type: 'GET_SYSTEM_LOGS_REQUEST',
  payload
});

export const getSystemLogsSuccess = (
  payload: GetSystemLogsResponse
): GetSystemLogsSuccessAction => ({
  type: 'GET_SYSTEM_LOGS_SUCCESS',
  payload
});

export const getSystemLogsFailure = (): GetSystemLogsFailureAction => ({
  type: 'GET_SYSTEM_LOGS_FAILURE'
});
